import {disableBodyScroll, enableBodyScroll} from 'body-scroll-lock';
import {MegaMenu} from '../mega-menu';

interface NavigationElement extends HTMLElement {
  navigation?: Navigation;
}

type Options = Partial<NavigationOptions>;

interface NavigationOptions {
  activeClass: string;
  closeEvent: string;
  closeSelector: string;
  triggerSelector: string;
}

export class Navigation {
  static defaults = {
    activeClass: 'is-active',
    closeEvent: 'close-offcanvas-nav',
    closeSelector: '[data-navigation-close]',
    triggerSelector: '[data-navigation-trigger]',
  };
  query = window.matchMedia('(min-width: 928px)');
  MegaMenu: MegaMenu;
  options: NavigationOptions;
  element: NavigationElement;
  clickHandler: EventListener;
  triggerHandler: EventListener;
  checkListener: any;
  closeListener: EventListener;
  trigger: HTMLElement;
  menuInstance: MegaMenu;

  constructor(element: NavigationElement, options?: Options) {
    if (!element || element.navigation) {
      return;
    }

    element.navigation = this;
    this.element = element;
    this.options = {
      ...Navigation.defaults,
      ...options,
    };

    const trigger = document.querySelector(
      this.options.triggerSelector,
    ) as HTMLElement;

    if (trigger) {
      this.trigger = trigger;
    }

    this.bind();
    this.check(this.query);
  }

  bind() {
    this.clickHandler = this.handleClick.bind(this);
    this.triggerHandler = this.handleTrigger.bind(this);
    this.closeListener = this.handleCloseEvent.bind(this);
    this.checkListener = this.check.bind(this);

    if (this.trigger) {
      this.trigger.addEventListener('click', this.triggerHandler);
    }

    this.element.addEventListener('click', this.clickHandler);
    this.query.addListener(this.checkListener);
    document.documentElement.addEventListener(
      this.options.closeEvent,
      this.closeListener,
    );
  }

  handleTrigger() {
    this.toggle();
  }

  handleClick(event: Event) {
    const target = event.target as HTMLElement;
    const match = target.closest(this.options.closeSelector) as HTMLElement;

    if (!match) {
      return;
    }

    this.close();
  }

  handleCloseEvent() {
    if (this.isActive()) {
      this.close();
    }
  }

  check(media: MediaQueryList) {
    if (!media.matches) {
      this.destroyMenu();
      this.close();
      return;
    }

    this.menuInstance = this.setupMenu();
  }

  open() {
    disableBodyScroll(this.element);
    this.element.classList.add(this.options.activeClass);
    this.trigger.classList.add(this.options.activeClass);
    document.body.classList.add('nav-open');
  }

  close() {
    enableBodyScroll(this.element);
    this.element.classList.remove(this.options.activeClass);
    this.trigger.classList.remove(this.options.activeClass);
    document.body.classList.remove('nav-open');
  }

  toggle() {
    this.isActive() ? this.close() : this.open();
  }

  isActive(): boolean {
    return this.element.classList.contains(this.options.activeClass);
  }

  setupMenu(element: HTMLElement = this.element): MegaMenu {
    return new MegaMenu(element, {
      itemSelector: '.navigation__item',
    });
  }

  destroyMenu() {
    if (this.menuInstance) {
      this.menuInstance.destroy();
    }
  }

  destroy() {
    if (this.trigger) {
      this.trigger.removeEventListener('click', this.triggerHandler);
    }

    this.element.removeEventListener('click', this.clickHandler);
    this.query.removeListener(this.checkListener);
    document.documentElement.removeEventListener(
      this.options.closeEvent,
      this.closeListener,
    );
    this.element.navigation = undefined;
    this.close();
  }
}
